module.exports = __webpack_public_path__ + "static/media/express1.d638bd34.png";